import type { useTranslation } from 'react-i18next'
import type { BriefingStep } from '@/shared/briefing'
import type { EmcBriefingStep } from '../../utils/emcLegislationBriefing'

export function toV2EmcBriefingStep(
  step: EmcBriefingStep,
  translate: ReturnType<typeof useTranslation>['t']
): BriefingStep {
  return {
    key: step.key,
    status: step.status,
    requiredness: step.requiredness,
    title: translate(
      `v2.pages.products.detail.emcBriefing.steps.items.${step.key}.title`
    ),
    description: translate(
      `v2.pages.products.detail.emcBriefing.steps.items.${step.key}.description`
    ),
    requirednessLabel: translate(
      `v2.pages.products.detail.emcBriefing.requiredness.${step.requiredness}`
    ),
  }
}
